import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCookieBite, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../i18n/LanguageContext';
import './CookieBanner.css';

const STORAGE_KEY = 'aid_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Petit délai pour apparaître après le chargement de la page
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-labelledby="cookie-title">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__icon">
          <FontAwesomeIcon icon={faCookieBite} />
        </div>
        <div className="cookie-banner__content">
          <h3 id="cookie-title">{t('cookieBanner.title')}</h3>
          <p>
            {t('cookieBanner.text')}{' '}
            <Link to="/confidentialite">{t('cookieBanner.policyLink')}</Link>.
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__btn cookie-banner__btn--secondary" onClick={handleReject}>
            {t('cookieBanner.reject')}
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--primary" onClick={handleAccept}>
            {t('cookieBanner.accept')}
          </button>
        </div>
        <button className="cookie-banner__close" onClick={handleReject} aria-label="Close">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
